export default __webpack_public_path__ + "static/Erik_Rovers_4-10857088025839b52d794bd32ba7b741.jpg";